<template>
  <div
    v-if="hasContent"
    class="guarantee-print-block"
    :style="{ fontSize: fontSize }"
  >
    <div class="guarantee-content" v-html="guaranteeHtml"></div>
  </div>
</template>

<script>
export default {
  name: "GuaranteePrintBlock",
  props: {
    html: {
      type: String,
      default: "",
    },
    businessId: {
      type: [Number, String],
      required: true,
    },
    branchId: {
      type: [Number, String],
      default: null,
    },
    guaranteeType: {
      type: String,
      default: "ABONO",
    },
    fontSize: {
      type: String,
      default: "inherit",
    },
    showDivider: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      guaranteeHtml: "",
    };
  },
  computed: {
    hasContent() {
      return !this.loading && !!String(this.guaranteeHtml || "").trim();
    },
  },
  watch: {
    html: {
      immediate: true,
      handler(value) {
        if (String(value || "").trim()) {
          this.guaranteeHtml = value;
          return;
        }

        this.loadGuarantee();
      },
    },
    businessId: {
      immediate: true,
      handler() {
        this.loadGuarantee();
      },
    },
    branchId() {
      this.loadGuarantee();
    },
    guaranteeType() {
      this.loadGuarantee();
    },
  },
  methods: {
    hasEmptyCachedGuarantee() {
      const api = this.$API && this.$API.businessGuarantees;
      if (!api || typeof api.peekEffectiveCache !== "function" || !this.businessId) {
        return false;
      }

      const entry = api.peekEffectiveCache({
        ID_Business: this.businessId,
        ID_Branch: this.branchId,
        GuaranteeType: this.guaranteeType,
      });

      return entry?.status === "empty";
    },
    async loadGuarantee() {
      if (String(this.html || "").trim()) {
        this.guaranteeHtml = this.html;
        return;
      }

      if (!this.businessId) {
        this.guaranteeHtml = "";
        return;
      }

      if (this.hasEmptyCachedGuarantee()) {
        this.guaranteeHtml = "";
        this.loading = false;
        return;
      }

      this.loading = true;
      try {
        const response = await this.$API.businessGuarantees.getEffective({
          ID_Business: this.businessId,
          ID_Branch: this.branchId,
          GuaranteeType: this.guaranteeType,
        });

        this.guaranteeHtml = (response && response.data && response.data.ContentHtml) || "";
      } catch (error) {
        this.guaranteeHtml = "";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.guarantee-print-block {
  width: 100%;
  font-family: Arial, Helvetica, sans-serif !important;
  white-space: normal !important;
  word-break: normal;
  overflow-wrap: normal;
}

.guarantee-content {
  width: 100%;
  line-height: 1.5;
  white-space: normal !important;
  word-break: normal;
  overflow-wrap: normal;
}

.guarantee-content ::v-deep *,
.guarantee-content ::v-deep p {
  font-family: inherit !important;
  font-size: inherit !important;
  line-height: inherit !important;
  white-space: normal !important;
  word-break: normal;
  overflow-wrap: normal;
}

.guarantee-content ::v-deep p,
.guarantee-content ::v-deep div,
.guarantee-content ::v-deep li {
  display: block;
  margin: 0 0 4px;
  padding: 0;
}

.guarantee-content ::v-deep ul,
.guarantee-content ::v-deep ol {
  margin: 0 0 8px 18px;
  padding: 0;
  list-style-position: outside;
}

.guarantee-content ::v-deep li {
  margin-bottom: 4px;
}
</style>
